import {LauncherOverrides} from '../config-interfaces/launcher-overrides';
import {IStorageService} from '../../services/storage/storage.service.interface';
import {ILoggerService} from '../../services/logger/logger.service.interface';
import {LAUNCHER_DATA_STORAGE_KEY} from "../../../app-consts";
const overrideJson = require('json-override');

export class LauncherOverridesReader {
  constructor(private _storage: IStorageService, private _logger: ILoggerService) {

  }

  private _getLauncherOverrides() {

    try {
      let cgp_client: any = this._storage.getJson(LAUNCHER_DATA_STORAGE_KEY);
      if(cgp_client) {
        return cgp_client.clientData;
      }
    } catch (err) {
      this._logger.error('Failed to read cgp_client from local storage', err);
    }

    return null;
  }

  private _getOrbitSpecificConfigOverrides() {
    try {
      let orbitSpecificOverrides = this._storage.getJson('orbitConfigOverrides');
      if(orbitSpecificOverrides) {
        return orbitSpecificOverrides;
      }
    } catch (err) {
      this._logger.error('Failed to get orbitConfigOverrides from local storage', err);
    }


    return null;
  }

  getOverrides() : LauncherOverrides | null {
    let launcherOverrides: LauncherOverrides = this._getLauncherOverrides();
    let orbitSpecificOverrides = this._getOrbitSpecificConfigOverrides();


    if(launcherOverrides || orbitSpecificOverrides) {
      launcherOverrides = (launcherOverrides || {}) as LauncherOverrides;

      if(orbitSpecificOverrides) {
        launcherOverrides.orbit = launcherOverrides.orbit || {};
        launcherOverrides.orbit.configs = launcherOverrides.orbit.configs || {};
        overrideJson(launcherOverrides.orbit.configs, orbitSpecificOverrides);
      }

      return launcherOverrides;
    }

    return null;
  }
}




